import { useEffect } from 'react'
import { useUserSettings } from '../api/hooks/useSettings'
import { exerciseProcessor } from '../services/exerciseProcessor'

/**
 * Hook to ensure ExerciseProcessor is initialized with user's muscle group overrides
 * This ensures that all exercise classification throughout the app respects user preferences
 */
export function useExerciseProcessor() {
  const { data: userSettings } = useUserSettings()

  useEffect(() => {
    if (userSettings?.muscleGroupOverrides) {
      exerciseProcessor.setMuscleGroupOverrides(userSettings.muscleGroupOverrides)
    }
  }, [userSettings?.muscleGroupOverrides])

  return exerciseProcessor
}